<script>
    import { isOfferVisible } from "./stores";
    $: display = $isOfferVisible ? "block" : "none";
</script>

<div class="offer" id="OFFER" style="display:{display}">
    <div class="textDiv" id="OFFER_TEXT">
        <center>
            <b>Маълумотнома!</b>
        </center>
        <p style="text-indent: 2em;">
            Ташкили шартбанди ва харидори дар Идорахои шомил ба хамин хат
            (линия) ва Идорахои Букмекер ива бозии Лото.
        </p>
        <p>
            Пешниходи бози ва шартбандии (ставок) мазкур робитаи дутарафа байни
            Ташкилкунанда ва шартбанд (мизоч) муайян карда, мувофики Конуни
            Чумхурии Точикистон «дар бораиичозатномадихи ва баьзе намудхои
            фаъолият» аз 3.04.2007, №172 «Оид ба тсдики Низомнома дар бораи
            хучусиятхои ичозатномадихи ба баьзе намудхои фаъолият».
        </p>
        <p>
            Ташкилкунандаи шартбанди (ставок) дар Чумхурии Точикистон он
            Ширкатхо ва Чамъиятхое ки мувофики Конуни Чумхурии Точикистон «Дар
            бораи ичозатномадихи ва баьзе намудхои фаъолият» ва дорои
            Ичозатномаи гузаронидани ташкилу нигохдории кассахои тотализатор,
            Идорахои Букмекер ива гузаронидани бозии Лото доро мебошан, ки дар
            Вазорати Молияи Чумхурии Точикистон ба кайд гирифта шудааст, амал ва
            фаъолият мекунанд.
        </p>
        <p>
            Нархи мукарраршудаи шартбанди (ставок) дар хачми 10 дирам, 20 дирам,
            50 дирам, ва 100 сомо иборат мебошад.
        </p>
        <p>
            Фонди бурдноки аз чониби Ташкилкунанда ба иштирокчи бо тарики
            кассахо (операторы) ё сомонаи ширкатхо 70% ташкил дода пардохт карда
            мешавад, инчунин ба иштирокчиён (гостей) мукофотхо (джек-поты)
            ташкил карда мешавад инчунин иштирокчиен метавонан дар сомонаи
            дилхох Ширкате, ки дорои ин хат мебошад шахсияти худро дар кайд
            монда шартбанди ва харидори намоянд.
        </p>
    </div>
    <div class="buttonsDiv">
        <button id="CANCEL" class="offerButton">РОЗИ НЕСТАМ</button>
        <button
            id="OK"
            class="offerButton"
            on:click={() => {
                $isOfferVisible = false;
                localStorage.setItem("offer", $isOfferVisible);
            }}>РОЗИЯМ</button
        >
    </div>
</div>

<style>
    .offer {
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        width: 98%;
        height: 98%;
        background-color: #3d6886;
        padding: 1% 1% 1% 1%;
        border: solid 2px #daebf8;
        overflow: auto;
        font-family: "Arial";
        font-size: 14px; /*1.5vmin;*/
        color: #accff9;
        text-align: left;
        border: none;
    }
    .textDiv {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        position: fixed;
        left: 2%;
        top: 2px;
        width: 95%;
        height: 50%;
        background-color: #3d6886;
        padding: 1% 1% 1% 1%;
        overflow: auto;
        font-family: "Arial";
        font-size: 12px;
        color: #accff9;
        text-align: center;
    }
    .buttonsDiv {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        top: 80%;
        width: 98%;
        height: 18%;
        margin: 0 auto;
    }
    .offerButton {
        position: relative;
        top: 20px;
        width: 200px;
        height: 50px;
        cursor: pointer;
        text-align: center;
        text-align: -webkit-center;
        margin: 0 auto;
    }
</style>
